import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import Seo from "../components/Seo";
import { PageHero, CTABand, RequestCareForm } from "../components/Shared";
import { getArea } from "../data/areas";
import { SERVICES } from "../data/services";
import { Check, ArrowRight, MapPin } from "lucide-react";

const BASE = "https://carefirstoh.com";

const AreaDetail = () => {
  const { slug } = useParams();
  const a = getArea(slug);
  if (!a) return <Navigate to="/service-areas" replace />;

  const schema = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    name: "CareFirst Home Health Services LLC",
    areaServed: { "@type": "City", name: `${a.name}, OH` },
    address: { "@type": "PostalAddress", addressLocality: "Columbus", addressRegion: "OH", addressCountry: "US" },
    telephone: "614-368-2239",
  };

  return (
    <div>
      <Seo title={a.seoTitle} description={a.seoDesc} canonical={`${BASE}/service-areas/${a.slug}`} jsonLd={schema} />
      <PageHero title={`Home Health Care in ${a.name}, Ohio`} subtitle={a.intro} crumbs={[{ label: "Home", to: "/" }, { label: "Service Areas", to: "/service-areas" }, { label: a.name }]} />

      <section className="bg-white py-16">
        <div className="max-w-[1150px] mx-auto px-4 grid lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2 space-y-8">
            <div className="flex items-center gap-2 text-[#4ca82f] font-semibold"><MapPin size={20} /> {a.county}</div>
            <p className="text-[#4a4a4a] text-[17px] leading-relaxed">{a.body}</p>
            <div>
              <h2 className="font-display text-[#16357a] text-[24px] font-semibold mb-4">Local Care Highlights</h2>
              <ul className="space-y-3">
                {a.highlights.map((h, i) => (
                  <li key={i} className="flex items-start gap-3 text-[#444] text-[15px]"><span className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-[#4ca82f] flex items-center justify-center"><Check size={13} className="text-white" strokeWidth={3} /></span>{h}</li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="font-display text-[#16357a] text-[24px] font-semibold mb-4">Services Available in {a.name}</h2>
              <div className="flex flex-wrap gap-2">
                {SERVICES.map((s) => (
                  <Link key={s.slug} to={`/services/${s.slug}`} className="px-4 py-2 rounded-full bg-[#eef6ea] text-[#16357a] font-semibold text-[13px] hover:bg-[#16357a] hover:text-white transition-colors">{s.name}</Link>
                ))}
              </div>
            </div>
          </div>
          <aside className="lg:col-span-1">
            <div className="bg-[#eef6ea] rounded-2xl p-6 sticky top-28">
              <h3 className="font-display text-[#16357a] text-[22px] font-semibold mb-1">Request Care in {a.name}</h3>
              <p className="text-[#666] text-[13px] mb-5">We'll contact you to check eligibility and get started.</p>
              <RequestCareForm />
            </div>
          </aside>
        </div>
      </section>

      <CTABand />
    </div>
  );
};

export default AreaDetail;
